import {PropRef, useEffect} from 'preact/hooks';

export default function setValueOnMount(ref: PropRef<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, value: string) {
  useEffect(() => {
    if (ref && ref.current) {
      ref.current.value = value;
    }
  }, [value])
}